import React from 'react';
import { css, cx } from 'emotion';

import OutboundLink from 'site-react/core/OutboundLink';
import theme from 'site-react/theme';

// I know we shouldn't normally add ints to theme constants.
// However, this is what we have to do to make trustpilot
// play nice. This is due to them using images of text,
// and how the star in the trustpilot image goes above the hight
// of the text.
const maxHeight = theme.spacing.md + 2;

const divStyle = css`
  align-items: flex-end;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
`;

const smallImageStyle = css`
  max-height: ${theme.spacing.md}px;
  margin-right: ${theme.spacing.sm}px;
`;

const largeImageStyle = css`
  max-height: ${maxHeight}px;
  margin-right: ${theme.spacing.sm}px;
`;

const spanStyle = css`
  align-items: flex-end;
  display: flex;
  justify-content: center;
`;

const TrustPilot = ({ isInverted = false, location = '' }) => (
  <OutboundLink
    analyticsMetadata={{ location }}
    href="https://uk.trustpilot.com/review/hubblehq.com"
    target="_blank"
  >
    <div className={cx(divStyle, theme.utilities.hiddenOnPercy)}>
      <img
        src={`https://emailsignature.trustpilot.com/newsletter/en-GB/1/5c69ce05c6c6b50001f636f8/text1${
          isInverted ? '_dark' : ''
        }@2x.png`}
        className={smallImageStyle}
        alt="Human score"
      />
      <img
        src="https://emailsignature.trustpilot.com/newsletter/en-GB/1/5c69ce05c6c6b50001f636f8/stars@2x.png"
        className={largeImageStyle}
        alt="Trustpilot Stars"
      />
      <span className={spanStyle}>
        <img
          src={`https://emailsignature.trustpilot.com/newsletter/en-GB/1/5c69ce05c6c6b50001f636f8/text2${
            isInverted ? '_dark' : ''
          }@2x.png`}
          className={smallImageStyle}
          alt="number of reviews"
        />
        <img
          src={`https://emailsignature.trustpilot.com/brand/n/1/logo${
            isInverted ? '_dark' : ''
          }.png`}
          className={largeImageStyle}
          alt="Trustpilot Logo"
        />
      </span>
    </div>
  </OutboundLink>
);

export default TrustPilot;
